import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a8ba268"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "© 2025", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "北京星汉未来网络科技有限公司", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "emblem" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("span", null, [
      _createVNode(_component_a_button, {
        type: "link",
        target: "_blank",
        href: $data.href.record
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 版权所有"),
          _hoisted_3,
          _createTextVNode("京ICP备2021024542号-3 ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["href"])
    ]),
    _createElementVNode("span", null, [
      _createVNode(_component_a_button, {
        type: "link",
        target: "_blank",
        href: $data.href.recordWeb
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 京公网安备 11010802035850号 ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["href"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}